var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('p',[_vm._v("1. 认证审核：教师基本资料和个人资质需要审核；")]),_c('p',[_vm._v("2. 认证审核：只有审核通过后才能发布课程；")]),_c('p',[_vm._v("3. VIP：未开通VIP情况下，教师发布的服务，每日限制发布服务次数为1次，VIP用户发布服务次数无限制；")])])
}]

export { render, staticRenderFns }